import type {BuildTypeId, BuildTypeHierarchy} from '../../../../../../types'
import {notNull} from '../../../../../../utils/guards'

export const hierarchyToBuildTypesList = (item?: BuildTypeHierarchy): BuildTypeId[] =>
  item?.type === 'BUILD_TYPE'
    ? [item.id].filter(notNull)
    : item?.children.flatMap(hierarchyToBuildTypesList) ?? []
